module.exports = __webpack_public_path__ + "img/Purple.6ff75832.svg";